import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrackIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_27650_87975)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 40,
				fill: "url(#paint0_linear_27650_87975)"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_27650_87975",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: -23,
				y: 5,
				width: 55,
				height: 55,
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 4.5,
					cy: 32.5,
					r: 27.5,
					fill: "#D9D9D9"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_27650_87975)",
				children: /* @__PURE__ */ _jsx("path", {
					opacity: .2,
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-4.70758 -0.652925H25.3157C29.92 -0.652925 33.6526 3.0796 33.6526 7.6839V37.7072C33.6526 40.6068 32.1723 43.1607 29.9262 44.6543C29.6519 39.6975 28.5421 34.8166 26.6378 30.2195C24.4224 24.871 21.1753 20.0113 17.0818 15.9178C12.9882 11.8243 8.12854 8.57712 2.7801 6.36172C-1.81705 4.45752 -6.6979 3.34763 -11.6546 3.0734C-10.161 0.827339 -7.60714 -0.652925 -4.70758 -0.652925ZM-13.0434 7.55023C-13.0441 7.59471 -13.0444 7.63926 -13.0444 7.6839V16.9636C-9.4425 17.0886 -5.88922 17.8587 -2.55427 19.24C1.10296 20.7549 4.426 22.9753 7.22513 25.7744C10.0242 28.5736 12.2446 31.8966 13.7595 35.5538C15.1409 38.8888 15.911 42.4421 16.0359 46.044H25.3157L25.3702 46.0439L25.4493 46.043C25.3213 41.2055 24.3065 36.4294 22.4524 31.9531C20.4647 27.1543 17.5512 22.794 13.8784 19.1212C10.2055 15.4484 5.84523 12.5349 1.04643 10.5472C-3.42984 8.69305 -8.20589 7.67826 -13.0434 7.55023ZM-13.0444 30.9186V21.4971C-10.0376 21.6199 -7.07318 22.2718 -4.28794 23.4255C-1.18035 24.7127 1.64327 26.5994 4.02172 28.9778C6.40016 31.3563 8.28685 34.1799 9.57405 37.2875C10.7278 40.0728 11.3796 43.0373 11.5024 46.044H2.08093C1.96649 44.2737 1.56191 42.5316 0.881191 40.8882C0.0668354 38.9222 -1.12678 37.1358 -2.63151 35.6311C-4.13624 34.1263 -5.92262 32.9327 -7.88865 32.1184C-9.53203 31.4376 -11.274 31.0331 -13.0444 30.9186ZM-13.0444 35.4621V37.7072C-13.0444 42.3115 -9.31188 46.044 -4.70758 46.044H-2.46251C-2.56813 44.8693 -2.85136 43.7153 -3.30426 42.6219C-3.89095 41.2055 -4.75087 39.9185 -5.83492 38.8345C-6.91897 37.7504 -8.20593 36.8905 -9.62232 36.3038C-10.7157 35.8509 -11.8697 35.5677 -13.0444 35.4621ZM-17.5747 7.6839C-17.5747 0.577583 -11.8139 -5.18323 -4.70758 -5.18323H25.3157C32.4221 -5.18323 38.1829 0.577583 38.1829 7.6839V37.7072C38.1829 44.8135 32.4221 50.5743 25.3157 50.5743H-4.70758C-11.8139 50.5743 -17.5747 44.8135 -17.5747 37.7072V7.6839Z",
					fill: "white"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_27650_87975",
		x1: 20,
		y1: 0,
		x2: 20,
		y2: 40,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#07CAAE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#03B9B0"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_27650_87975",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
			fill: "white"
		})
	})] })]
});
export default SvgTrackIcon;
